import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import { ColumnsPhotoAlbum } from 'react-photo-album'
import 'react-photo-album/columns.css'
import { Map, MapMarker, MarkerContent, MarkerTooltip } from '../../components/ui/map'
import { useTheme } from '../../contexts/ThemeContext'
import { formatDate } from '../../utils/dateUtils'
import PageLayout from '../../components/PageLayout'

function usePhotoDimensions(images, title) {
  const [photos, setPhotos] = useState(null)

  useEffect(() => {
    if (!images?.length) return
    let cancelled = false
    Promise.all(
      images.map(src => new Promise(resolve => {
        const img = new window.Image()
        img.onload = () => resolve({ src, width: img.naturalWidth, height: img.naturalHeight, alt: title })
        img.onerror = () => resolve({ src, width: 4, height: 3, alt: title })
        img.src = src
      }))
    ).then(result => { if (!cancelled) setPhotos(result) })
    return () => { cancelled = true }
  }, [images, title])

  return photos
}

export const TravelPost = ({ post }) => {
  const { theme } = useTheme()
  const { title, date, description, images, location, content } = post
  const photos = usePhotoDimensions(images, title)

  return (
    <PageLayout title={title || 'Travel'} description={description} className="blog-post">
      <div className="blog-container">
        <div className="blog-header">
          <Link to="/blog" className="back-link">← Back to Blog</Link>
          <h1 className="blog-title">{title}</h1>
          {date && <div className="blog-date">{formatDate(date)}</div>}
        </div>

        {photos && photos.length > 0 && (
          <div className="travel-gallery">
            <ColumnsPhotoAlbum
              photos={photos}
              spacing={6}
              padding={0}
              columns={w => (w < 600 ? 2 : 3)}
            />
          </div>
        )}

        {location && (
          <div className="travel-map">
            <div style={{ height: '220px', width: '100%', borderRadius: '4px', overflow: 'hidden' }}>
              <Map
                center={[location.lng, location.lat]}
                zoom={12}
                theme={theme}
              >
                <MapMarker longitude={location.lng} latitude={location.lat}>
                  <MarkerContent>
                    <div style={{
                      width: 14,
                      height: 14,
                      background: '#cc0000',
                      borderRadius: '50%',
                      border: '2px solid #ffffff',
                      boxShadow: '0 1px 4px rgba(0,0,0,0.6)',
                    }} />
                  </MarkerContent>
                  {location.name && (
                    <MarkerTooltip>{location.name}</MarkerTooltip>
                  )}
                </MapMarker>
              </Map>
            </div>
          </div>
        )}

        <div className="blog-content markdown-content">
          <ReactMarkdown>{content ?? ''}</ReactMarkdown>
        </div>
      </div>
    </PageLayout>
  )
}
